export function Steps(
  props: React.SVGAttributes<SVGSVGElement>
): React.ReactElement {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 1.05333C20 1.5134 19.6267 1.88667 19.1667 1.88667H15V6.05333C15 6.51514 14.6285 6.88667 14.1667 6.88667H10.5556V10.4978C10.5556 10.9578 10.1823 11.3311 9.72222 11.3311H6.11111V14.9422C6.11111 15.404 5.73958 15.7756 5.27778 15.7756H0.833333C0.373264 15.7756 0 15.404 0 14.9422C0 14.4804 0.373264 14.1089 0.833333 14.1089H4.44444V10.4978C4.44444 10.0394 4.81944 9.66444 5.27778 9.66444H8.88889V6.05333C8.88889 5.595 9.26389 5.22 9.72222 5.22H13.3333V1.05333C13.3333 0.593265 13.7083 0.220001 14.1667 0.220001H19.1667C19.6285 0.220001 20 0.593265 20 1.05333Z"
        fill="black"
      />
    </svg>
  );
}
